import React from "react";
import "./style.less";
import { Icon } from "semantic-ui-react";

function NewCityCta() {
  return (
    <a href="/city/create">
      <div className="NewCityCta">
        <Icon name="add" />
      </div>
    </a>
  );
}

NewCityCta.defaultProps = {};

NewCityCta.propTypes = {};

export default NewCityCta;
